var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modern-suggestion"},[_c('span',{staticClass:"modern-suggestion-title"},[_vm._v(" "+_vm._s(_vm.suggestionText)+" ")]),_c('v-btn',{staticClass:"modern-suggestion-action-button",attrs:{"color":"primary"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.actionText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }